import React, { useState, useImperativeHandle } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import { UPDATE_RECURRING_PLAN_DATE } from '../../../constants/endpoints';

const UpdateNextDonationDateDialog = React.forwardRef((props, ref) => {
    const [show, setShow] = useState(false);
    const [date, setDate] = useState('');
    const [planId, setPlanId] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        handleShow(id) {
            setPlanId(id);
            // Optionally, you can format currentDate to 'YYYY-MM-DD' to pre-fill the input
            setDate(''); 
            setError('');
            setShow(true);
        }
    }));

    const handleClose = () => {
        if (!loading) setShow(false);
    };

    // Calculate the minimum allowed date (Current Date + 2 days)
    const getMinDate = () => {
        const today = new Date();
        today.setDate(today.getDate() + 2);
        return today.toISOString().split('T')[0];
    };

    const handleSave = () => {
        if (!date) {
            setError("Please select a date.");
            return;
        }

        const selectedDate = new Date(date);
        const minDate = new Date(getMinDate());
        
        // Normalize times to midnight for accurate comparison
        selectedDate.setHours(0, 0, 0, 0);
        minDate.setHours(0, 0, 0, 0);

        if (selectedDate < minDate) {
            setError("Date must be at least 2 days from the current date.");
            return;
        }

        setLoading(true);
        
        // Execute the API Call
        axios.patch(UPDATE_RECURRING_PLAN_DATE, { id: planId, next_donation_date: date })
            .then((res) => {
                setLoading(false);
                if (res?.data?.status) {
                    handleClose();
                    if (props.callback) props.callback(); // Refresh the parent component
                } else {
                    setError(res?.data?.message || "Failed to update date.");
                }
            })
            .catch((error) => {
                setLoading(false);
                setError("An error occurred while updating the date.");
            });
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="h5">Update Next Donation Date</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label>Select New Date <span className="text-danger">*</span></label>
                    <input
                        type="date"
                        className="form-control"
                        value={date}
                        min={getMinDate()}
                        onChange={(e) => {
                            setDate(e.target.value);
                            setError('');
                        }}
                    />
                    {error && <p className="text-danger mt-2 mb-0">{error}</p>}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
});

export default UpdateNextDonationDateDialog;